module.exports = __webpack_public_path__ + "assets/img/18_1853.2a78b07a.jpg";